module.exports = __webpack_public_path__ + "assets/img/baigongying_1.a813fac9.jpg";